import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
//import Card from '@material-ui/core/Card';
//import CardContent from '@material-ui/core/CardContent';
//import Typography from '@material-ui/core/Typography';


const styles = theme => ({
  card: {
    margin: 2,
    boxShadow: 'none',
    fontFamily: 'Nunito Sans Regular!important',
    fontSize:'14pt',
  },
  cardHeader: {
    //backgroundColor:'#10526a',
    color: '#fff',
  },
  statValue: {
    marginRight: '2px',
    //fontFamily: 'Nunito Sans!important',
  },
  cardContent: {
    //fontFamily: 'Nunito Sans!important',
  },
  label: {
    color: '#105269!important',
    //fontFamily: 'Nunito Sans!important',
  },
  statContainer: {
    textAlign: 'left',
  },
  imageBlock: {
    display: 'block',
    margin: '0 auto',
    textIndent: '-9999px',
    //background: 'url("/images/electricity_production.svg")',
    //width: '40px',
    //height: '40px',
    //backgroundSize: '40px 40px',
    backgroundSize: 'contain!important',
    backgroundRepeat: 'no-repeat!important',
    backgroundPosition: 'center center!important',
    width: '80%',
    height: 0,
    minWidth: '40px',
    maxWidth: '40px',
    minHeight: '40px',
    maxHeight: '40px',
  },
  energysum: {
    background: 'url("/images/spw_indicator/production.svg")',
  },
  residentialfacilities: {
    background: 'url("/images/spw_indicator/solar_residential.svg")',
  },
  industrialfacilities: {
    background: 'url("/images/spw_indicator/solar_industrial.svg")',
  },
  energyaspercentageofdemand: {
    background: 'url("/images/spw_indicator/demand.svg")',
  },
  energyaspercentageofdemandpeak: {
    background: 'url("/images/spw_indicator/peak.svg")',
  },
  electricalvehicles: {
    background: 'url("/images/spw_indicator/electric_vehicles.svg")',
  },
  co2avoided: {
    background: 'url("/images/spw_indicator/CO2.svg")',
  },
  clearLeft: {
    clear: 'left',
  }
});

function Indicator(props) {
  const { classes } = props;

  let selectedImageSelector = props.name.replace(/_/g, "")

  {
    /*
  
    switch (props.name) {
    case 'energy_sum':
        selectedImage = 'url("/images/electricity_production.svg")';
      break
    case 'residential_facilities':
        selectedImage = 'url("/images/solar_residential.svg")';
      break
    case 'industrial_facilities':
        selectedImage = 'url("/images/solar_industrial.svg")';
      break
    case 'energy_as_percentage_of_demand_peak':
        selectedImage = 'url("/images/peak_demand.svg")';
      break
    case 'nb_household_covered':
        selectedImage = 'url("/images/daily_demand.svg")';
      break
    case 'electrical_vehicles':
        selectedImage = 'url("/images/electric_car.svg")';
      break
    case 'co2-avoided':
        selectedImage = 'url("/images/co2_emissions.svg")';
      break
    default:
  }

   if (props.name && props.name==='peak'){
     if (props.label === 'Niet beschikbaar'){
       return (
         <Card className={classes.card}>
           <CardContent className={classes.cardContent}>
             <Typography component="p" className={classes.statValue}>
               {(props.unit?(props.unit==='%'?props.unit:''):'')}
             </Typography>
             <Typography component="p" className={classes.label}>
               van de totale vraag
             </Typography> 
             <Typography component="p" className={classes.label}>
               <strong>{props.label}</strong>
             </Typography> 
           </CardContent>
         </Card>
       );
     }
     else {
       return (
         <Card className={classes.card}>
           <CardContent className={classes.cardContent}>
             <Typography component="p" className={classes.statValue}>
               {(props.value.toLocaleString('nl-BE'))+(props.unit?(props.unit==='%'?props.unit:''):'')}
             </Typography>
             <Typography component="p" className={classes.label}>
               van de totale vraag
             </Typography> 
             <Typography component="p" className={classes.label}>
               {props.date?"op ":''}<strong>{props.date?props.date:''}</strong>{props.date?" ":""}om <strong>{props.label}</strong> (piek)
             </Typography> 
           </CardContent>
         </Card>
       );
     }
     
   }
   if (props.name && props.name==='energy_sum'){
     return (
       <Card className={classes.card}>
         <CardContent className={classes.cardContent}>
           <Typography component="p" className={classes.statValue}>
             {(props.value.toLocaleString('nl-BE',{minimumFractionDigits: 1, maximumFractionDigits: 1}))+(props.unit?(props.unit==='%'?props.unit:''):'')}
           </Typography>
           <Typography component="p" className={classes.label}>
             {(props.unit?(props.unit==='%'?'':(props.unit + ' ')):'') + props.label}
           </Typography> 
         </CardContent>
       </Card>
     );
   }
   */
  }
  return (
    <Grid item container >
      <Grid item xs={props.name === 'residential_facilities' || props.name === 'industrial_facilities' ? 4 : 2}>
        <div className={classes.imageBlock + " " + classes[selectedImageSelector]}></div>
        {/*<img className={classes.statImage} src={image} alt={props.label}/>*/}
      </Grid>
      <Grid item xs={props.name === 'residential_facilities' || props.name === 'industrial_facilities' ? 8 : 10} className={classes.statContainer}>
        <span className={classes.statValue + ' bottomgrey'}>{(props.value.toLocaleString('nl-BE')) + (props.unit ? (props.unit === '%' ? props.unit : '') : '')}</span>
        <span className={(props.name === 'residential_facilities' || props.name === 'industrial_facilities' ? classes.clearLeft : '') + ' bottomgrey'}>{(props.unit ? (props.unit === '%' ? '' : (' '+props.unit)) : '') + ' ' + props.label}</span>
      </Grid>
    </Grid>
  );
}

Indicator.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string,
  value: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(Indicator);